export default function createPNUDTitle(titleArray, language) {
  return (
    <>
      {titleArray.map((str, key) => {
        if (str.color === "gold") {
          return (
            <span key={key} style={{ color: "var(--pnud-gold)" }}>
              {str["text"][language ?? "es"]}{" "}
            </span>
          );
        } else {
          return (
            <span key={key} style={{ color: "black" }}>
              {str["text"][language ?? "es"]}{" "}
            </span>
          );
        }
      })}
    </>
  );
}
